var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.91429,
    cy: 2.91429,
    r: 2.91429,
    transform: "matrix(-1 0 0 1 9.01428 1.625)",
    stroke: "#BE7637",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.7778C1 11.151 1.39405 10.5918 1.98437 10.381V10.381C4.6458 9.43049 7.5542 9.43049 10.2156 10.381V10.381C10.8059 10.5918 11.2 11.151 11.2 11.7778V12.7363C11.2 13.6014 10.4338 14.266 9.57732 14.1436L9.29178 14.1028C7.17467 13.8004 5.02533 13.8004 2.90822 14.1028L2.62268 14.1436C1.76624 14.266 1 13.6014 1 12.7363V11.7778Z",
    stroke: "#BE7637",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.95b629494573a524c6ee75833b378903.svg";
export { ForwardRef as ReactComponent };